export default function WhySTEMForge() {
  const differentiators = [
    {
      title: 'Academic Rigor',
      icon: 'ri-book-open-line',
      color: 'from-blue-600 to-blue-400',
      borderColor: 'border-blue-500',
      description: 'Curriculum-aligned programs mapped to CBSE, ICSE, and State Board standards with comprehensive assessment frameworks.',
      features: [
        'NEP 2020 compliant curriculum design',
        'Learning outcome-based assessments',
        'Integration with existing subjects',
        'Quarterly progress reports'
      ],
      metric: '12-Month',
      metricLabel: 'Integration Cycle'
    },
    {
      title: 'Infrastructure Excellence',
      icon: 'ri-building-line',
      color: 'from-teal-600 to-teal-400',
      borderColor: 'border-teal-500',
      description: 'Complete lab setup with cutting-edge equipment, safety compliance, and ongoing maintenance support.',
      features: [
        'ISO-certified lab infrastructure',
        'Premium robotics & AI equipment',
        'Safety protocols & insurance',
        'Annual maintenance included'
      ],
      metric: '100%',
      metricLabel: 'Safety Compliance'
    },
    {
      title: 'Continuous Support',
      icon: 'ri-customer-service-2-line',
      color: 'from-purple-600 to-purple-400',
      borderColor: 'border-purple-500',
      description: 'Comprehensive teacher training, parent engagement programs, and dedicated support throughout the academic year.',
      features: [
        '40+ hours teacher training',
        'Monthly professional development',
        'Parent orientation workshops',
        '24/7 technical support'
      ],
      metric: '100+',
      metricLabel: 'Trained Teachers'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-blue-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-600 text-sm font-semibold uppercase tracking-wider rounded-full mb-4">
            The STEMForge Difference
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Beyond Training.<br />
            <span className="font-light">True Academic Integration.</span>
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            We're not just a vendor—we're your long-term academic partner committed to transforming education through comprehensive STEM integration.
          </p>
        </div>

        {/* Differentiator Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {differentiators.map((item, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-3xl p-8 border-4 ${item.borderColor} hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${idx === 1 ? 'md:translate-y-8' : ''}`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center -mt-12 mb-5 shadow-lg`}>
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>

              {/* Description */}
              <p className="text-gray-600 text-sm mb-5 leading-relaxed">{item.description}</p>

              {/* Features */}
              <ul className="space-y-3 mb-6">
                {item.features.map((feature, fIdx) => (
                  <li key={fIdx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Metric */}
              <div className="pt-5 border-t border-gray-200">
                <div className="text-2xl font-bold text-gray-900">{item.metric}</div>
                <div className="text-xs text-gray-600">{item.metricLabel}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-blue-600 to-blue-500">
                <tr>
                  <th className="px-6 py-4 text-left text-white font-semibold">Aspect</th>
                  <th className="px-6 py-4 text-center text-white font-semibold">Traditional Vendors</th>
                  <th className="px-6 py-4 text-center text-white font-semibold">STEMForge Partnership</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Curriculum Integration', false, true],
                  ['Teacher Training & Support', false, true],
                  ['Annual Academic Planning', false, true],
                  ['Ongoing Maintenance', false, true],
                  ['Parent Engagement Programs', false, true],
                ].map((row, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-6 py-4 text-gray-900 font-medium">{row[0]}</td>
                    <td className="px-6 py-4 text-center">
                      {row[1] ? (
                        <i className="ri-checkbox-circle-fill text-green-500 text-2xl"></i>
                      ) : (
                        <i className="ri-close-circle-fill text-red-500 text-2xl"></i>
                      )}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {row[2] ? (
                        <i className="ri-checkbox-circle-fill text-green-500 text-2xl"></i>
                      ) : (
                        <i className="ri-close-circle-fill text-red-500 text-2xl"></i>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
